import * as actions from "../../actions/codigosEmpleado";
import { Preview } from "../../../types/IAction";
import {
  GetCodigosEmpleado,
  PostCodigoEmpleado,
  PostEnviarComunicado
} from "../../reducers/codigosEmpleado";

export interface CodigoEmpleadoAdminDispatcher {
  getCodigosEmpleadoByUser: (
    idUser: number
  ) => Promise<Preview<GetCodigosEmpleado>>;
  getCodigosEmpleadoByCodigo: (
    codigo: string
  ) => Promise<Preview<GetCodigosEmpleado>>;
  postCodigoEmpleado: (idUser: number) => Promise<Preview<PostCodigoEmpleado>>;
  postEnviarComunicadoCodigosEmpleado: (
    idUser: number
  ) => Promise<Preview<PostEnviarComunicado>>;
  clearCodigosEmpleado: () => void;
}

export const codigoEmpleadoAdminDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => CodigoEmpleadoAdminDispatcher = dispatch => ({
  getCodigosEmpleadoByUser: (idUser: number) =>
    dispatch(actions.getCodigosEmpleadoByUser(idUser)),
  getCodigosEmpleadoByCodigo: (codigo: string) =>
    dispatch(actions.getCodigosEmpleadoByCodigo(codigo)),
  postCodigoEmpleado: (idUser: number) =>
    dispatch(actions.postCodigoEmpleado(idUser)),
  postEnviarComunicadoCodigosEmpleado: (idUser: number) =>
    dispatch(actions.postEnviarComunicadoCodigosEmpleado(idUser)),
  clearCodigosEmpleado: () => dispatch(actions.clearCodigosEmpleado())
});
